import { useSignal } from "@preact/signals-react";
import { useEffect } from "react";
import { ErrorField } from "../../../../types/ErrorField";
import { getErrorMessage } from "../../../../utils/formErrorUtils";
import CurrencyInput from "../../../molecules/CurrencyInput";
import { MdOutlineScore } from "react-icons/md";
import FileUpload from "../../../molecules/FileUpload";
import { FiTrash2, FiCopy } from "react-icons/fi";
import { toast } from 'react-toastify';

interface Props {
    form: any;
    errorFields: ErrorField[];
    changeForm: (field: string, value: string | File | null) => void;
    editForm?: boolean;
}

const GuarantorRetailFormTab: React.FC<Props> = ({ form, errorFields, changeForm, editForm = false }) => {

    const logoPreview = useSignal<string | null>(form.logo && typeof form.logo === 'string' ? form.logo : null);

    useEffect(() => {
        if (form.logo && typeof form.logo === 'string' && !logoPreview.value) {
            logoPreview.value = form.logo;
        }
    }, [form.logo]);

    const handleUpload = (file: File) => {
        const url = URL.createObjectURL(file);
        logoPreview.value = url;
        changeForm('logo', file);
    };

    const handleRemove = () => {
        logoPreview.value = null;
        changeForm('logo', null);
    };

    return (
        <div className="p-4 m-4">
            <div className="grid grid-cols-12 gap-4">
                <CurrencyInput
                    id="guaranteePercentage"
                    label="Aval"
                    className="col-span-2"
                    prefix="%"
                    value={form.guaranteePercentage}
                    fractionDigits={0}
                    onChange={(value) => changeForm("guaranteePercentage", value.toString())}
                    errorMessage={getErrorMessage(errorFields, "guaranteePercentage")}
                    disabled={!editForm}
                />
                <div />
                <CurrencyInput
                    id="score"
                    label="Score"
                    className="col-span-2"
                    prefix={<MdOutlineScore />}
                    value={form.score}
                    fractionDigits={2}
                    onChange={(value) => changeForm("score", value.toString())}
                    errorMessage={getErrorMessage(errorFields, "score")}
                    disabled={!editForm}
                />
                <div />
                <CurrencyInput
                    id="limit"
                    label="Limite Aprovado"
                    className="col-span-2"
                    prefix="R$"
                    fractionDigits={2}
                    value={form.limit}
                    onChange={(value) => changeForm("limit", value.toString())}
                    errorMessage={getErrorMessage(errorFields, "limit")}
                    disabled={!editForm}
                />
            </div>

            <div className="grid grid-cols-12 gap-4 mt-6">
                <div className="col-span-7">
                    <label className="block text-sm text-gray-500 mb-1">Link único da parceira</label>
                    <div className="flex items-center">
                        <span className="inline-flex items-center px-4 py-2 text-sm text-gray-900 bg-gray-100 border border-r-0 border-gray-300 rounded-l-md whitespace-nowrap">
                            https://emprestimo.agrolend.agr.br/parceiro/
                        </span>
                        <input
                            id="alias"
                            name="alias"
                            type="text"
                            className="flex-1 min-w-0 px-3 py-2 text-sm text-gray-900 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed dark:bg-slate-700 dark:text-white dark:border-gray-600"
                            placeholder="revenda-modelo"
                            value={form.alias || ''}
                            onChange={(e) => {
                                const sanitized = e.target.value
                                    .toLowerCase()
                                    .replace(/[^a-z0-9_-]/g, '');
                                changeForm("alias", sanitized);
                            }}
                            disabled={!editForm}
                        />
                        <button
                            type="button"
                            className="inline-flex items-center px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-l-0 border-gray-300 rounded-r-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                            disabled={!form.alias}
                            onClick={() => {
                                const fullUrl = `https://emprestimo.agrolend.agr.br/parceiro/${form.alias}`;
                                navigator.clipboard.writeText(fullUrl);
                                toast.success('Link copiado!');
                            }}
                            title="Copiar link da parceira"
                        >
                            <FiCopy className="w-4 h-4" />
                        </button>
                    </div>
                    {getErrorMessage(errorFields, "alias") && (
                        <p className="mt-1 text-sm text-red-600">{getErrorMessage(errorFields, "alias")}</p>
                    )}
                </div>
            </div>
            <div className="grid grid-cols-1 gap-4 mt-6">
                {logoPreview.value ? (
                    <div className="relative inline-block w-fit">
                        <img src={logoPreview.value ?? undefined} alt="Logo preview" className="h-80 w-auto rounded shadow border" />
                        {editForm && (
                            <button
                                type="button"
                                onClick={handleRemove}
                                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-2 shadow-md ring-2 ring-white hover:bg-red-700 transition"
                                title="Remover imagem"

                            >
                                <FiTrash2 className="w-4 h-4" />
                            </button>
                        )}
                    </div>
                ) : (
                    <FileUpload
                        id="logo"
                        name="logo"
                        label="Arquivo enviado:"
                        errorMessage={getErrorMessage(errorFields, 'logo')}
                        onUploadFile={handleUpload}
                        onRemoveFile={handleRemove}
                        accept=".png, .jpeg, .jpg"
                        info="PNG, JPEG ou JPG (MAX. 2MB)"
                    />
                )}
            </div>
        </div>
    );
};

export default GuarantorRetailFormTab;
